import { create } from 'zustand';
import type { SupportedLocale } from '../../domain/formatters/currency';

interface LocaleState {
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => void;
  toggleLocale: () => void;
}

/** UI locale (EN/BN). Persisted to localStorage — UI preference only, never auth data. */
export const useLocaleStore = create<LocaleState>()((set, get) => ({
  locale: 'en',
  setLocale: (locale) => set({ locale }),
  toggleLocale: () => set({ locale: get().locale === 'en' ? 'bn' : 'en' }),
}));
